import { Component } from "@angular/core";

@Component({
  selector: "preview-button",
  templateUrl: "./preview-button.component.html",
  styleUrls: ["./preview-button.component.scss"],
})
export class PreviewButtonComponent {
  constructor() {}
}
